﻿import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup, FormControl, NgForm, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { APIEntityService } from '../../_services/entity/API-entity';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { MatDialog, MatTable } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/observable/of';
import { Location } from '@angular/common';

export interface Element {
  //'Sno': number;
  'Record ID': string;
  'Action Performed': string;
  'Action Date': string;
  'Action By': string;
  // 'Remarks': string;

}
const ELEMENT_DATA: Element[] = [
  //   { 'Sno': "", 'Record ID': '',  'Action Performed': '' , 'Action Date':'', 'Action By':''},
];




@Component({
  selector: 'app-entity-auditlog',
  templateUrl: './entity-auditlog.component.html',
  styleUrls: ['./entity-auditlog.component.css']
})
export class EntityAuditLogComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<any>;
  entityRefNo: any;
  response: any;
  reqStatus: any
  EntityStatus: any;
  disableForm: boolean;
  showRejectReason: boolean = false;
  showRemarks: boolean = false;
  showModifyReason: boolean = false;
  poi_type: any;
  poa_type: any;
  poafilename: any;
  poifilename: any;
  approveFlag: boolean = false
  dataSource: any;

  // rejectFlag: boolean = false
  // modifyFlag: boolean = false  




  constructor(private fb: FormBuilder,
    //private es: APILoginService,
    private es: APIEntityService,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    private _route: ActivatedRoute,
    public dialog: MatDialog,
    private _location: Location,
    private router: Router) {
  }//end of constructor

  //displayedColumns: string[] = [ 'srno', 'Record ID', 'Action Performed','Action Date', 'Action By'];
  displayedColumns: string[] = [ 'Record ID', 'Action Date', 'Action By', 'User Role', 'Action Performed', 'Tat', 'Remarks'];  

  // dataSource = new MatTableDataSource(ELEMENT_DATA);


  dataSubject = new BehaviorSubject<any[]>([]);

  entityForm: FormGroup;
  selectedValue: String;
  name: string;
  position: number;
  weight: number;
  symbol: string;
  modiflist: any;
  rejectlist: any;
  header_id: any;



  get f() { return this.entityForm.controls; }


  ngOnInit() {

    this.entityForm = this.fb.group({
      request_type: [''],
      urn_no: [''],
      creation_timestamp: ['',],
      assigned_timestamp: ['',],
      paymen_applicable: ['',],

      //  remarks: ['', [Validators.required, Validators.maxLength(200), Validators.minLength(10)]],
      rej_reason: ['',],
      modification_reason: ['',],
      header_id: [''],

    });//end of entityForm  


    this.getEntityDetails();
    console.log("this.ELEMENT_DATA[i]", ELEMENT_DATA)
    //  this.dataSource.paginator = this.paginator;
    //  this.dataSource.sort = this.sort;
  } // oninit

  backClicked() {
    this._location.back();
  }


  getSubstring(filename) {
    return filename.substring(filename.indexOf('.') + 1)
  }

  getEntityDetails() {
    this._route.params.subscribe((params) => {
      this.entityRefNo = params['urn'];
    })
    var data = {
      SR_URN: this.entityRefNo,  
      Collection: "Entity",
    }
    this.es.getAuditLog(data).subscribe({
      next: value => {
        console.log("getAuditLog", value) 
        this.dataSubject.next(value);
        this.dataSource = new MatTableDataSource();
        this.dataSource = new MatTableDataSource(value);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    })
  }
}  